import { render, staticRenderFns } from "./PlayersAndProblemContainer.vue?vue&type=template&id=d742557e"
import script from "./PlayersAndProblemContainer.vue?vue&type=script&lang=js"
export * from "./PlayersAndProblemContainer.vue?vue&type=script&lang=js"
import style0 from "./PlayersAndProblemContainer.vue?vue&type=style&index=0&id=d742557e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports